/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { di } from 'react-magnetic-di';

type Props = {
	url: string;
};

const FullPageRedirect = ({ url }: Props): null => {
	di(window);
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	window.location.assign(url);
	return null;
};

export default FullPageRedirect;
